import React from "react";
import {MenuItem, TextField} from "@mui/material";
import {renderRanks} from "../../utils/ranks";
import {RANKS} from "../../constants";

const RankField = (props) => {
    const {value, onChange} = props;

    return <div className="field">
        <TextField
            required={true}
            label="Ranks"
            value={typeof value === 'string' ? (value ? value.split(',') : []) : (value || [])}
            onChange={(event) => onChange(event.target.value)}
            options={RANKS}
            select={true}
            SelectProps={{
                multiple: true,
                renderValue: renderRanks,
            }}
        >
            {Object.entries(RANKS).map(([key, value]) =>
                <MenuItem key={key} value={key}>{value}</MenuItem>)}
        </TextField>
    </div>
}

export default RankField;
